import Select from 'react-select'

import s from './Filter.module.sass'

function Filter({
    selectedLocation,
    setSelectedLocation,
    selectedType,
    setSelectedType,
    selectedBranch,
    setSelectedBranch,
}: {
    selectedLocation: string[]
    setSelectedLocation: (value: string[]) => void
    selectedType: string[]
    setSelectedType: (value: string[]) => void
    selectedBranch: string[]
    setSelectedBranch: (value: string[]) => void
}) {
    return (
        <div className={s.Filter}>
            <div className={s.Select}>
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={[
                        { label: 'Canberra', value: 'canberra' },
                        { label: 'Sydney', value: 'sydney' },
                        { label: 'Brisbane', value: 'brisbane' },
                        { label: 'Newcastle', value: 'newcastle' },
                        { label: 'Launceston', value: 'launceston' },
                    ]}
                    value={selectedLocation?.map((item) => ({
                        label: item.charAt(0).toUpperCase() + item.slice(1),
                        value: item,
                    }))}
                    onChange={(option) => {
                        const values = option?.map((item: any) => item.value) || []
                        setSelectedLocation(values)
                    }}
                    placeholder="Location"
                    isMulti
                    isSearchable={false}
                />
            </div>
            <div className={s.Select}>
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={[
                        { label: 'Full-time', value: 'full-time' },
                        { label: 'Part-time', value: 'part-time' },
                        { label: 'Casual', value: 'casual' },
                        { label: 'Contract', value: 'contract' },
                    ]}
                    value={selectedType?.map((item) => ({
                        label: item.charAt(0).toUpperCase() + item.slice(1),
                        value: item,
                    }))}
                    onChange={(option) => {
                        const values = option?.map((item: any) => item.value) || []
                        setSelectedType(values)
                    }}
                    placeholder="Type of work"
                    isMulti
                    isSearchable={false}
                />
            </div>
            <div className={s.Select}>
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={[
                        { label: 'Benmax', value: 'benmax' },
                        { label: 'Benmax Fabrication', value: 'benmax-fabrication' },
                        { label: 'Benmax Service', value: 'benmax-service' },
                        { label: 'Amos Air', value: 'amos-air' },
                        { label: 'Hydro Industries', value: 'hydro-industries' },
                    ]}
                    value={selectedBranch?.map((item) => ({
                        label: item.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                        value: item,
                    }))}
                    onChange={(option) => {
                        const values = option?.map((item: any) => item.value) || []
                        setSelectedBranch(values)
                    }}
                    placeholder="Branch"
                    isMulti
                    isSearchable={false}
                />
            </div>
        </div>
    )
}

export default Filter
